import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Users } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { Reveal } from "./Sections";

function CountUp({ value }) {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-60px" });
    const [display, setDisplay] = useState(0);

    useEffect(() => {
        if (!inView) return;
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            setDisplay(value);
            return;
        }
        const controls = animate(0, value, {
            duration: 1.6,
            ease: [0.16, 1, 0.3, 1],
            onUpdate: (v) => setDisplay(Math.round(v)),
        });
        return () => controls.stop();
    }, [inView, value]);

    return (
        <span ref={ref} className="font-heading font-extrabold text-6xl sm:text-7xl text-forest tabular-nums" data-testid="social-proof-count">
            {new Intl.NumberFormat("fr-FR").format(display)}
        </span>
    );
}

export function SocialProof() {
    const { data } = useSite();
    const sp = data?.social_proof;
    if (!sp || !sp.visible) return null;

    return (
        <section className="bg-pearl py-20 sm:py-24" data-testid="social-proof-section">
            <div className="container-bc text-center">
                <Reveal>
                    <p className="eyebrow flex items-center justify-center gap-2 mb-5">
                        <Users size={14} /> Ils ont rejoint l'expérience BODYCOACHIA
                    </p>
                    {sp.count > 0 ? (
                        <>
                            <CountUp value={sp.count} />
                            <p className="mt-4 text-ink-soft text-base sm:text-lg max-w-xl mx-auto" data-testid="social-proof-label">
                                {sp.label}
                            </p>
                        </>
                    ) : (
                        <div className="max-w-xl mx-auto" data-testid="social-proof-empty">
                            <p className="font-heading font-bold text-ink text-2xl">La communauté se construit</p>
                            <p className="mt-3 text-ink-soft leading-relaxed">
                                Soyez parmi les premiers à rejoindre l'expérience BODYCOACHIA — chaque compte affiché ici est un compte réel créé sur ce site.
                            </p>
                        </div>
                    )}
                </Reveal>
            </div>
        </section>
    );
}
